import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { WhiteSpaceMode } from './WhiteSpaceMode.ts';
import { WhiteSpaceRuleComponent } from './WhiteSpaceRuleComponent.tsx';

export { WhiteSpaceMode };

const configValidator = yup
  .object({
    value: yup
      .mixed<WhiteSpaceMode>()
      .oneOf(Object.values(WhiteSpaceMode))
      .notRequired(),
  })
  .notRequired()
  .noUnknown();

export type IRuleWhiteSpaceType = yup.InferType<typeof configValidator>;

/**
 * Applica una trasformazione sugli spazi bianchi del valore stringa.
 *
 * - `replace`: sostituisce tab, CR e LF con spazi
 * - `collapse`: replace + rimuove spazi iniziali/finali + riduce spazi multipli a uno
 * - nessuna selezione: nessuna modifica (equivalente a `preserve`)
 */
export const WhiteSpaceRule: IRuleType<IRuleWhiteSpaceType> = {
  type: RuleType.WhiteSpace,
  name: 'Gestione spazi bianchi',
  configComponent: WhiteSpaceRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return schema.when(['$trustedEnvironment'], (values, schema) => {
      const trustedEnvironment: boolean = values[0];
      // Lato frontend non servono validazioni aggiuntive, saranno eseguite solo lato Backend
      if (!trustedEnvironment) return schema;

      return schema.transform((value: string | null | undefined) => {
        if (value == null) return value;

        if (rule.value === WhiteSpaceMode.Replace) {
          return value.replace(/[\t\n\r]/g, ' ');
        }

        if (rule.value === WhiteSpaceMode.Collapse) {
          return value
            .replace(/[\t\n\r]/g, ' ')
            .replace(/ +/g, ' ')
            .trim();
        }

        return value;
      });
    });
  },
};
